// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1GeVs","selects":"Documents_selects__10rlJ"};